<template>
  <div class="sidebar">
    <div
      v-for="period of periods"
      :key="period.id"
      class="period q-px-sm q-py-md"
      :class="{ active: period.id === activeId }"
      @click="$emit('period-changed', period.id)"
    >
      <div class="text-body-3 text-secondary-1">{{ getPeriodDateFormat(period) }}</div>
      <div class="chip text-lowercase-btn text-white-1 q-px-sm" :class="period.status.name">
        {{ period.status.name }}
      </div>
    </div>
  </div>
</template>

<script>
// Libraries
import moment from 'moment'

export default {
  props: {
    periods: {
      type: Array,
      required: true
    },

    activeId: Number
  },

  methods: {
    getPeriodDateFormat(period) {
      const endDate = period.end_date
        ? moment(period.end_date, this.globalVarsAndFns.BEdateFormat).format('DD MMM YYYY')
        : 'One time purchase'
      return `${moment(period.start_date, this.globalVarsAndFns.BEdateFormat).format('DD MMM YYYY')} - ${endDate}`
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  border-right: 1px solid var(--r-white-4);

  .period {
    margin-right: -2px;
    border-bottom: 1px solid var(--r-white-4);
    cursor: pointer;

    &.active {
      border-right: 2px solid var(--r-primary-1);
    }

    &.active,
    &:hover {
      background: var(--r-white-2);
    }
  }

  .chip {
    border-radius: var(--r-space-md);
    width: fit-content;

    &.pending {
      background: var(--r-grey-2);
    }
    &.accepted {
      background: var(--r-primary-2);
    }
    &.cancelled {
      background: var(--r-danger-1);
    }
  }
}
</style>
